import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["wrapper", "updateLabel", "updateSubLabel", "submitButton", "completeButton", "closeButton", "form"];

  connect() {
    this.addEventListeners();
  }

  addEventListeners() {
    if (!this.hasFormTarget || !this.hasSubmitButtonTarget) return;

    this.formTarget.addEventListener("submit", (event) => {
      event.preventDefault();
      this.handleSubmit();
    });
  }

  async handleSubmit() {
    this.toggleButtonLoading();

    const formData = new FormData(this.formTarget);
    const actionUrl = this.formTarget.getAttribute("action");

    try {
      const response = await fetch(actionUrl, {
        method: 'PATCH',
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json"
        }
      });

      if (response.ok) {
        const data = await response.json();
        
        if (data.status === "transfer_team_mccd_reuploaded") {
          this.handleMccdReuploaded();
        } else {
          this.handleSuccess();
        }
      } else {
        this.handleError();
      }
    } catch (error) {
      this.handleError();
    }
  }

  handleSuccess() {
    this.wrapperTarget.classList.add("success");
    this.updateLabelTarget.textContent = "Status updated successfully";
    this.updateSubLabelTarget.textContent = "The document status has been updated. You may now close this window.";
    this.completeButtonTarget.classList.remove("hidden");
    this.submitButtonTarget.classList.add("hidden");
    this.closeButtonTarget.classList.add("hidden");
  }

  handleMccdReuploaded() {
    this.wrapperTarget.classList.add("success");
    this.updateLabelTarget.textContent = "A new MCCD has been uploaded";
    this.updateSubLabelTarget.textContent = "To avoid errors, we'll refresh the page so you can see the latest document.";
    this.completeButtonTarget.classList.remove("hidden");
    this.completeButtonTarget.textContent = "Okay";
    this.submitButtonTarget.classList.add("hidden");
    this.closeButtonTarget.classList.add("hidden");
  }

  handleError() {
    this.wrapperTarget.classList.add("error");
    this.updateLabelTarget.textContent = "Error updating status";
    this.updateSubLabelTarget.textContent = "There was an error updating the status. Please try again.";
    this.toggleButtonLoading();
  }

  toggleButtonLoading() {
    if (!this.hasSubmitButtonTarget) return;

    const spinnerElement = this.submitButtonTarget.querySelector("[name='spinner']");
    const buttonTextElement = this.submitButtonTarget.querySelector("[name='button-text']");
    const currentlyLoading = this.submitButtonTarget.disabled;

    this.submitButtonTarget.disabled = !this.submitButtonTarget.disabled;

    if (spinnerElement) {
      spinnerElement.classList.toggle("hidden", currentlyLoading);
    }

    if (buttonTextElement) {
      const originalText = buttonTextElement.textContent;
      buttonTextElement.textContent = currentlyLoading ? originalText.replace("...", "") : `${originalText}...`;
    }
  }
}
